import { useContext } from "react";
import AppContext from "../../../services/app-context-services";
import { _c } from "../../../services/text-services";
import Modal, { ModalProps } from "../modal/modal.component";
// @ts-ignore 
import styles from "./exit-profile.component.module.scss";

function AppExitProfile({ onClose }: ModalProps) {
  const appCtx = useContext(AppContext);
  const {logout} = appCtx;

  return (
    <Modal onClose={onClose} hasCloseBtn>
      <div
        className={_c(
          styles,
          "exit-profile-popup-container custom-modal__body"
        )}
      >
        <h2 className={_c(styles, "title mt-2 mb-4")}>
          مطمئنی میخوای خارج بشی ؟
        </h2>
        <div className={_c(styles, "d-flex justify-content-center")}>
          <button className={_c(styles, "exit-btn")} onClick={() => {
            logout();
          }}>
            بله
          </button>
          <button className={_c(styles, "exit-btn")} onClick={onClose}>
            فعلا نه
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default AppExitProfile;
